import * as actionTypes from '../actions/actionTypes';
import {Map} from 'immutable';

const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

const initialState = {
    uid: null,
    user: null,
    error: null,
    success: null,
    isAuthenticated: false,
    activePageID: null,
    activePageType: null,
    created: null,
    completed: null,
    incomplete: null
};


const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.AUTH_START:
            return updateObject(state, {loading: true})
        case actionTypes.AUTH_FAIL:
            return updateObject(state, {error: action.error, success: null})
        case actionTypes.AUTH_SUCCESS:
            return updateObject(state, {success: action.success, error: null})
        case actionTypes.AUTH_RESET:
            return updateObject(state, {error: null, success: null})
        case actionTypes.USER_COUNT:
            return updateObject(state, {created: action.created, completed: action.completed, incomplete: action.incomplete})

        case actionTypes.SIGN_UP:
            return updateObject(state, {
                uid: action.user && action.user.uid,
                user: action.user, 
                error: action.error, 
                isAuthenticated: action.isAuthenticated,
                activePageID: action.user && action.user.activePageID,
                activePageType: action.user && action.user.activePageType
            })
        case actionTypes.SIGN_IN_THIRD_PARTY:
            return updateObject(state, {
                    uid: action.user && action.user.uid,
                    user: action.user, 
                    error: action.error, 
                    isAuthenticated: action.isAuthenticated,
                    activePageID: action.user && action.user.activePageID,
                    activePageType: action.user && action.user.activePageType
                })
        case actionTypes.SIGN_IN:
            return updateObject(state, {
                uid: action.user && action.user.uid,
                user: action.user, 
                error: action.error,
                isAuthenticated: action.isAuthenticated,
                activePageID: action.user && action.user.activePageID,
                activePageType: action.user && action.user.activePageType
            })
        case actionTypes.SIGN_IN_EXISTING:
            return updateObject(state, {
                uid: action.user && action.user.uid,
                user: action.user,
                error: action.error,
                isAuthenticated: action.isAuthenticated,
                activePageID: action.user && action.user.activePageID,
                activePageType: action.user && action.user.activePageType,
                
            })
        
        case actionTypes.UPDATE_USER:
            return updateObject(state, {
                user: action.user,
                activePageID: action.user && action.user.activePageID,
                activePageType: action.user && action.user.activePageType,
                error: action.error,
            })

        case actionTypes.SIGN_OUT:
            return updateObject(state, {
                user: null, 
                error: null,
                isAuthenticated: null, 
                activePageID: null, 
                activePageType: null
            })


        case actionTypes.FORGOT_PASSWORD:
            return updateObject(state, {loading: false, errors: action.errors, resetPasswordEmailSent: action.resetPasswordEmailSent})

        default:
            return updateObject(state)
    }
};

export default reducer;
